import type { SortingState } from '@tanstack/react-table';
import type { Ordering } from './TableState';

export const mapSortingStateToOrdering = (sorting: SortingState): Ordering => {
  const firstSortingColumn = sorting[0] ? sorting[0] : undefined;

  return firstSortingColumn
    ? {
        column: firstSortingColumn.id,
        asc: !firstSortingColumn.desc,
      }
    : null;
};

export const mapOrderingToSortingState = (ordering: Ordering): SortingState => {
  if (!ordering) {
    return [];
  }

  return [
    {
      id: ordering.column,
      desc: !ordering.asc,
    },
  ];
};
